import {Component, input} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';

@Component({
  selector: 'app-product-save-label',
  templateUrl: './product-save-label.component.html',
  styleUrls: ['./product-save-label.component.scss'],
  imports: []
})
export class ProductSaveLabelComponent {

  product = input.required<WineProduct | undefined>();

  constructor(
  ) {
  }
}
